import { BaseAPI, Configuration, ConfigurationParameters, Middleware } from "../../@api";

import { apiConfig } from "../../environmentConfiguration";
import { IStoreContext } from "../stores/StoreContext";
import {
  AuthorizationHandlingMiddleware,
  ErrorResponseHandlingMiddleware,
  NotFoundResponseHandlingMiddleware,
  PaymentResponseHandlingMiddleware,
  ServerAvailabilityHandlingMiddleware,
  TokenRefreshMiddleware,
} from "./ApiMiddlewares";
import { ServerInternalErrorHandlingMiddleware } from "./ApiMiddlewares/ServerInternalErrorHandlingMiddleware";

export default abstract class GenericService<TApi extends BaseAPI, TApiService> {
  protected apiService: TApiService;

  constructor(
    protected readonly storeContext: IStoreContext,
    apiClass: new (configuration: Configuration) => TApi,
    apiServiceClass: new (api: TApi) => TApiService,
  ) {
    this.storeContext = storeContext;

    const configurationParameters: ConfigurationParameters = {
      basePath: apiConfig.baseUrl,
      accessToken: () => {
        return `Bearer ${this.storeContext.userStore.userAccessToken}`;
      },
    };

    const configuration = new Configuration(configurationParameters);
    const api = new apiClass(configuration).withMiddleware(
      ...this.beforeGlobalMiddlewares,
      ...this.globalMiddlewares,
      ...this.afterGlobalMiddlewares,
    );

    this.apiService = new apiServiceClass(api);
  }

  private get globalMiddlewares(): Middleware[] {
    return [
      new ServerInternalErrorHandlingMiddleware(this.storeContext.globalErrorsStore),
      new TokenRefreshMiddleware(this.storeContext.userStore),
      new AuthorizationHandlingMiddleware(this.storeContext.globalErrorsStore),
      new PaymentResponseHandlingMiddleware(this.storeContext.budgetStore, this.storeContext.globalErrorsStore),
      new NotFoundResponseHandlingMiddleware(this.storeContext.globalErrorsStore, this.storeContext.userStore),
    ];
  }

  protected get beforeGlobalMiddlewares(): Middleware[] {
    return [];
  }

  protected get afterGlobalMiddlewares(): Middleware[] {
    return [
      new ServerAvailabilityHandlingMiddleware(this.storeContext.globalErrorsStore),
      new ErrorResponseHandlingMiddleware(this.storeContext.globalErrorsStore),
    ];
  }
}
